// extracted by mini-css-extract-plugin
export default {"control":"ObjectsContentControl_control__JF1vS"};